<!-- Start Switcher -->
<div
  #switcher
  class="offcanvas switcher offcanvas-end"
  tabindex="-1"
  id="switcher-canvas"
  aria-labelledby="offcanvasRightLabel"
>
  <div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title text-default" id="offcanvasRightLabel">
      Switcher
    </h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="onClose()"
    ></button>
  </div>
  <div class="offcanvas-body">
    <nav class="border-bottom border-block-end-dashed">
      <div
        ngbNav
        #nav="ngbNav"
        class="nav nav-tabs nav-justified"
        id="switcher-main-tab"
        role="tablist"
      >
        <ng-container [ngbNavItem]="1">
          <button
            ngbNavLink
            class="nav-link"
            id="switcher-home-tab"
            data-bs-toggle="tab"
            data-bs-target="#switcher-home"
            type="button"
            role="tab"
            aria-controls="switcher-home"
            aria-selected="true"
          >
            Theme Styles
          </button>
          <ng-template ngbNavContent>
            <div
              class="tab-pane fade show border-0"
              id="switcher-home"
              role="tabpanel"
              aria-labelledby="switcher-home-tab"
              tabindex="0"
            >
              <div class="">
                <p class="switcher-style-head">Theme Color Mode:</p>
                <div class="row switcher-style gx-0">
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-light-theme"
                      >
                        Light
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="theme-style"
                        id="switcher-light-theme"
                        checked
                        (click)="themeChange('light', 'light')"
                        [checked]="localdata['valexdarktheme'] != 'dark'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-dark-theme">
                        Dark
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="theme-style"
                        id="switcher-dark-theme"
                        (click)="themeChange('dark', 'dark')"
                        [checked]="localdata['valexdarktheme'] == 'dark'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <p class="switcher-style-head">Directions:</p>
                <div class="row switcher-style gx-0">
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="myonoffswitch54">
                        LTR
                      </label>
                      <input
                        type="radio"
                        name="onoffswitch25"
                        id="myonoffswitch54"
                        class="form-check-input"
                        (click)="DirectionsChange('ltr')"
                        [checked]="localdata['valex-dir'] != 'rtl'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="myonoffswitch55">
                        RTL
                      </label>
                      <input
                        (click)="DirectionsChange('rtl')"
                        [checked]="localdata['dir'] == 'rtl'"
                        name="onoffswitch25"
                        id="myonoffswitch55"
                        class="form-check-input"
                        type="radio"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <p class="switcher-style-head">Navigation Styles:</p>
                <div class="row switcher-style gx-0">
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-vertical">
                        Vertical
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="navigation-style"
                        id="switcher-vertical"
                        (click)="NavigationChange('vertical')"
                        [checked]="localdata['valexlayout'] != 'horizontal'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-horizontal">
                        Horizontal
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="navigation-style"
                        id="switcher-horizontal"
                        [checked]="localdata['valexlayout'] == 'horizontal'"
                        (click)="NavigationChange('horizontal')"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="navigation-menu-styles">
                <p class="switcher-style-head">
                  Vertical & Horizontal Menu Styles:
                </p>
                <div class="row switcher-style gx-0 pb-2 gy-2">
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-menu-click">
                        Menu Click
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="navigation-menu-styles"
                        id="switcher-menu-click"
                        (click)="Menus('menu-click-closed', 'menu-click')"
                        [checked]="localdata['valexnavstyles'] == 'menu-click'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-menu-hover">
                        Menu Hover
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="navigation-menu-styles"
                        id="switcher-menu-hover"
                        (click)="Menus('menu-hover-closed', 'menu-hover')"
                        [checked]="localdata['valexnavstyles'] == 'menu-hover'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-icon-click">
                        Icon Click
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="navigation-menu-styles"
                        id="switcher-icon-click"
                        (click)="Menus('icon-click-closed', 'icon-click')"
                        [checked]="localdata['valexnavstyles'] == 'icon-click'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-icon-hover">
                        Icon Hover
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="navigation-menu-styles"
                        id="switcher-icon-hover"
                        (click)="Menus('icon-hover-closed', 'icon-hover')"
                        [checked]="localdata['valexnavstyles'] == 'icon-hover'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="sidemenu-layout-styles">
                <p class="switcher-style-head">Sidemenu Layout Styles:</p>
                <div class="row switcher-style gx-0 pb-2 gy-2">
                  <div class="col-sm-6">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-default-menu"
                      >
                        Default Menu
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="sidemenu-layout-styles"
                        id="switcher-default-menu"
                        checked
                        (click)="Layout('', 'overlay')"
                        [checked]="
                          localdata['valexverticalstyles'] != 'default-menu'"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-closed-menu"
                      >
                        Closed Menu
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="sidemenu-layout-styles"
                        id="switcher-closed-menu"
                        (click)="Layout('close-menu-close', 'closed')"
                        checked
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-icontext-menu"
                      >
                        Icon Text   
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="sidemenu-layout-styles"
                        id="switcher-icontext-menu"
                        (click)="Layout('icon-text-close', 'icontext')"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-icon-overlay"
                      >
                        Icon Overlay
                      </label>   
                      <input
                        class="form-check-input"
                        type="radio"
                        name="sidemenu-layout-styles"
                        id="switcher-icon-overlay"
                        (click)="Layout('icon-overlay-close', 'overlay')"
                        checked
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-detached">
                        Detached
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="sidemenu-layout-styles"
                        id="switcher-detached"
                        (click)="Layout('detached-close', 'detached')"
                        checked
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <p class="switcher-style-head">Page Styles:</p>
                <div class="row switcher-style gx-0">
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-regular">
                        Regular
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="page-styles"
                        id="switcher-regular"
                        (click)="PageChange('regular')"
                        [checked]="localdata['valex-page-mode'] != 'classic'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-classic">
                        Classic
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="page-styles"
                        id="switcher-classic"
                        (click)="PageChange('classic')"
                        [checked]="localdata['valex-page-mode'] == 'classic'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-modern">
                        Modern
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="page-styles"
                        id="switcher-modern"
                        (click)="PageChange('modern')"
                        [checked]="localdata['valex-page-mode'] == 'modern'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <p class="switcher-style-head">Layout Width Styles:</p>
                <div class="row switcher-style gx-0">
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-full-width">
                        Full Width
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="layout-width"
                        id="switcher-full-width"
                        (click)="WidthChange('full-width')"
                        [checked]="localdata['valex-width-mode'] != 'boxed'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-boxed">
                        Boxed
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="layout-width"
                        id="switcher-boxed"
                        (click)="WidthChange('boxed')"
                        [checked]="localdata['valex-width-mode'] == 'boxed'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <p class="switcher-style-head">Menu Positions:</p>
                <div class="row switcher-style gx-0">
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label class="form-check-label" for="switcher-menu-fixed">
                        Fixed
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="menu-positions"
                        id="switcher-menu-fixed"
                        (click)="MenuChange('fixed')"
                        [checked]="
                          localdata['valex-menu-position'] != 'scrollable'
                        "
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-menu-scroll"
                      >
                        Scrollable
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="menu-positions"
                        id="switcher-menu-scroll"
                        (click)="MenuChange('scrollable')"
                        [checked]="
                          localdata['valex-menu-position'] == 'scrollable'
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <p class="switcher-style-head">Header Positions:</p>
                <div class="row switcher-style gx-0">
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-header-fixed"
                      >
                        Fixed
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="header-positions"
                        id="switcher-header-fixed"
                        (click)="HeaderChange('fixed')"
                        [checked]="localdata['valexScroll'] != 'scrollable'"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-header-scroll"
                      >
                        Scrollable
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="header-positions"
                        id="switcher-header-scroll"
                        (click)="HeaderChange('scrollable')"
                        [checked]="localdata['valexScroll'] == 'scrollable'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <p class="switcher-style-head">Loader:</p>
                <div class="row switcher-style gx-0">
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-loader-enable"
                      >
                        Enable
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="page-loader"
                        id="switcher-loader-enable"
                        checked
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check switch-select">
                      <label
                        class="form-check-label"
                        for="switcher-loader-disable"
                      >
                        Disable
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        name="page-loader"
                        id="switcher-loader-disable"
                        [checked]="localdata['valexScroll'] == 'scrollable'"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <ng-container [ngbNavItem]="2">
          <button
            ngbNavLink
            class="nav-link"
            id="switcher-profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#switcher-profile"
            type="button"
            role="tab"
            aria-controls="switcher-profile"
            aria-selected="true"
          >
            Theme Colors
          </button>
          <ng-template ngbNavContent>
            <div class="theme-colors">
              <p class="switcher-style-head">Menu Colors:</p>
              <div class="d-flex switcher-style pb-2">
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-white"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Light Menu"
                    type="radio"
                    name="menu-colors"
                    id="switcher-menu-light"
                    (click)="menuTheme('light')"
                    [checked]="localdata['valexMenu'] == 'light'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-dark"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Dark Menu"
                    type="radio"
                    name="menu-colors"
                    id="switcher-menu-dark"
                    (click)="menuTheme('dark')"
                    [checked]="localdata['valexMenu'] == 'dark'"
                  />
                </div> 
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-primary"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Color Menu"
                    type="radio"
                    name="menu-colors"
                    id="switcher-menu-primary" 
                    (click)="menuTheme('color')"
                    [checked]="localdata['valexMenu'] == 'color'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-gradient"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Gradient Menu"
                    type="radio"
                    name="menu-colors"
                    id="switcher-menu-gradient"
                    (click)="menuTheme('gradient')"
                    [checked]="localdata['valexMenu'] == 'gradient'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input class="form-check-input color-input color-transparent"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Transparent Menu"
                    type="radio"
                    name="menu-colors"
                    id="switcher-menu-transparent"
                    (click)="menuTheme('transparent')"
                    [checked]="localdata['valexMenu'] == 'transparent'"
                  />
                </div>
              </div>
              <div class="px-4 pb-3 text-muted fs-11">
                Note:If you want to change color Menu dynamically change from
                below Theme Primary color picker
              </div>
            </div>  
            <div class="theme-colors">
              <p class="switcher-style-head">Header Colors:</p>
              <div class="d-flex switcher-style pb-2">
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-white"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Light Header"
                    type="radio"
                    name="header-colors"
                    id="switcher-header-light"
                    (click)="headerTheme('light')"
                    [checked]="localdata['valexHeader'] == 'light'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-dark"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Dark Header"
                    type="radio"
                    name="header-colors"
                    id="switcher-header-dark"   
                    (click)="headerTheme('dark')"
                    [checked]="localdata['valexHeader'] == 'dark'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-primary"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Color Header"
                    type="radio"
                    name="header-colors"
                    id="switcher-header-primary"
                    (click)="headerTheme('color')"
                    [checked]="localdata['valexHeader'] == 'color'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-gradient"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Gradient Header"
                    type="radio"
                    name="header-colors"
                    id="switcher-header-gradient"
                    (click)="headerTheme('gradient')"
                     [checked]="localdata['valexHeader'] == 'gradient'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-transparent"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Transparent Header"
                    type="radio"
                    name="header-colors"
                    id="switcher-header-transparent"
                    (click)="headerTheme('transparent')"
                    [checked]="localdata['valexHeader'] == 'transparent'"
                  />
                </div>
              </div>
              <div class="px-4 pb-3 text-muted fs-11">
                Note:If you want to change color Header dynamically change from
                below Theme Primary color picker
              </div>
            </div>
            <div class="theme-colors">
              <p class="switcher-style-head">Theme Primary:</p>
              <div class="d-flex flex-wrap align-items-center switcher-style">
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-primary-1"
                    type="radio"
                    name="theme-primary"
                    id="switcher-primary"
                    (click)="primary('58, 88, 146')"
                    [checked]="
                      localdata['valex-primary-mode'] == '49, 176, 176'
                    "
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-primary-2"
                    type="radio"
                    name="theme-primary"
                    id="switcher-primary1"
                    (click)="primary('49, 176, 176')"
                    [checked]="
                      localdata['valex-primary-mode'] == '49, 176, 176'
                    "
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-primary-3"
                    type="radio"
                    name="theme-primary"
                    id="switcher-primary2"
                    (click)="primary('170, 82, 216')"
                    [checked]="
                      localdata['valex-primary-mode'] == '170, 82, 216'
                    "
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-primary-4"
                    type="radio"
                    name="theme-primary"
                    id="switcher-primary3"
                    (click)="primary('80, 198, 118')"
                    [checked]="
                      localdata['valex-primary-mode'] == '80, 198, 118'
                    "
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-primary-5"
                    type="radio"
                    name="theme-primary"
                    id="switcher-primary4"
                    (click)="primary('244, 86, 86')"
                    [checked]="localdata['valex-primary-mode'] == '244, 86, 86'"
                  />
                </div>
                <div
                  class="form-check switch-select ps-0 mt-1 color-primary-light"
                >
                  <div class="theme-container-primary"></div>
                  <div class="pickr-container-primary">
                    <div class="pickr">
                      <button
                        type="button"
                        class="pcr-button"
                        role="button"
                        aria-label="toggle color picker dialog"
                        style="--pcr-color: rgba(1, 98, 232)"
                         id="lightPrimaryColorID"
                      data-id="rgb"
                      [style.background]="color1"
                      [cpAlphaChannel]="'disabled'"
                      [cpOutputFormat]="'hex'"
                      [(colorPicker)]="color1"
                      (cpSliderDragEnd)="dynamicLightPrimary($event)"
                      >
                    </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="theme-colors">
              <p class="switcher-style-head">Theme Background:</p>
              <div class="d-flex flex-wrap align-items-center switcher-style">
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-bg-1"
                    type="radio"
                    name="theme-background"
                    id="switcher-background"
                    (click)="background('20, 30, 96', '25, 38, 101','rgba(255,255,255,0.1)', 'dark', 'dark')"
                    [checked]="localdata['bodylightRGB'] == '25, 38, 101'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-bg-2"
                    type="radio"
                    name="theme-background"
                    id="switcher-background1"
                    (click)="
                      background('15, 95, 95', '16, 104, 104','rgba(255,255,255,0.1)', 'dark', 'dark')
                    "
                    [checked]="localdata['bodylightRGB'] == '16, 104, 104'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-bg-3"
                    type="radio"
                    name="theme-background"
                    id="switcher-background2"
                    (click)="
                      background('87, 48, 121', '98, 51, 140','rgba(255,255,255,0.1)','dark', 'dark')
                    "
                    [checked]="localdata['bodylightRGB'] == '98, 51, 140'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-bg-4"
                    type="radio"
                    name="theme-background"
                    id="switcher-background3"
                    (click)="
                      background('26, 93, 48', '28, 103, 53','rgba(255,255,255,0.1)','dark', 'dark')
                    "
                    [checked]="localdata['bodylightRGB'] == '28, 103, 53'"
                  />
                </div>
                <div class="form-check switch-select me-3">
                  <input
                    class="form-check-input color-input color-bg-5"
                    type="radio"
                    name="theme-background"
                    id="switcher-background4"
                    (click)="
                      background('157, 41, 41', '172, 56, 56','rgba(255,255,255,0.1)','dark', 'dark')
                    "
                    [checked]="localdata['bodylightRGB'] == '172, 56, 56'"
                  />
                </div>
                <div
                  class="form-check switch-select ps-0 mt-1 tooltip-static-demo color-bg-transparent"
                >
                  <div class="theme-container-background">
                    <button>nano</button>
                  </div>
                  <div class="pickr-container-background">
                    <div class="pickr">
                       <button type="button"
                          role="button"
                          aria-label="toggle color picker dialog"
                          class="color-bg-transparent pcr-button"
                          [style.background]="color1"
                          [cpAlphaChannel]="'disabled'"
                          [cpOutputFormat]="'hex'"
                          [(colorPicker)]="color1"
                          (cpSliderDragEnd)="dynamicTranparentBgPrimary($event)"
                      >
                      </button> 
                    </div>
                  </div> 
                </div>
              </div>
            </div>
            <div class="menu-image mb-3">
              <p class="switcher-style-head">Menu With Background Image:</p>
              <div class="d-flex flex-wrap align-items-center switcher-style">
                <div class="form-check switch-select m-2">
                  <input
                    class="form-check-input bgimage-input bg-img1"
                    type="radio"
                    name="theme-background"
                    id="switcher-bg-img"
                    (click)="ImageTheme('bgimg1')"
                    [checked]="localdata['bgimg'] == 'bgimg1'"
                  />
                </div>
                <div class="form-check switch-select m-2">
                  <input
                    class="form-check-input bgimage-input bg-img2"
                    type="radio"
                    name="theme-background"
                    id="switcher-bg-img1"
                    (click)="ImageTheme('bgimg2')"
                    [checked]="localdata['bgimg'] == 'bgimg2'"
                  />
                </div>
                <div class="form-check switch-select m-2">
                  <input
                    class="form-check-input bgimage-input bg-img3"
                    type="radio"
                    name="theme-background"
                    id="switcher-bg-img2"
                    (click)="ImageTheme('bgimg3')"
                    [checked]="localdata['bgimg'] == 'bgimg3'"
                  />
                </div>
                <div class="form-check switch-select m-2">
                  <input
                    class="form-check-input bgimage-input bg-img4"
                    type="radio"
                    name="theme-background"
                    id="switcher-bg-img3"
                    (click)="ImageTheme('bgimg4')"
                    [checked]="localdata['bgimg'] == 'bgimg4'"
                  />
                </div>
                <div class="form-check switch-select m-1">
                  <input
                    class="form-check-input bgimage-input bg-img5"
                    type="radio"
                    name="theme-background"
                    id="switcher-bg-img4"
                    (click)="ImageTheme('bgimg5')"
                    [checked]="localdata['bgimg'] == 'bgimg5'"
                  />
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div [ngbNavOutlet]="nav"></div>
      <div class="d-grid canvas-footer"> 
        <a  (click)="reset()" href="javascript:void(0);" id="reset-all" class="btn btn-danger m-1">Reset</a> 
     </div>
    </div>
  </div>
</div>
<!-- End Switcher -->
